export default "__VITE_ASSET__7Lhbf4uG__"